import { resetButton, resetInput } from "@/lib/styles";
import { SVGCross } from "@/lib/svg";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
  border-bottom: solid 1px;
  padding-bottom: 0.4rem;
  border-color: ${({ theme }) => theme.colors.middleGrey};
`;

export const Input = styled.input`
  ${resetInput}
  display: block;
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  font-weight: 400;
  font-size: 1.25rem;
  line-height: 1;
  padding-right: 2rem;
  width: 100%;

  &::placeholder {
    color: ${({ theme }) => theme.colors.black};
    opacity: 1;
  }
`;

export const Button = styled.button`
  ${resetButton}
  cursor: pointer;
  width: 1rem;
  height: 1rem;
`;

export const CloseIcon = styled(SVGCross)`
  width: 100%;
`;
